import apiFetch from '../apiFetch'

export default function () {    
  return apiFetch({endPoint: `Analisis/getPICTraits`, method: 'GET'})
}
